import * as React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface TimePickerProps {
  value?: Date;
  onChange?: (date: Date) => void;
}

export function TimePicker({ value, onChange }: TimePickerProps) {
  const hours = value ? value.getHours() : 0;
  const minutes = value ? value.getMinutes() : 0;

  const handleTimeChange = (newHours: number, newMinutes: number) => {
    if (onChange) {
      const newDate = value ? new Date(value) : new Date();
      newDate.setHours(newHours);
      newDate.setMinutes(newMinutes);
      onChange(newDate);
    }
  };

  return (
    <div className="flex items-center space-x-2">
      <div className="grid gap-1">
        <Label htmlFor="hours" className="text-xs">
          Hours
        </Label>
        <Input
          id="hours"
          type="number"
          min="0"
          max="23"
          value={hours}
          onChange={(e) =>
            handleTimeChange(parseInt(e.target.value) || 0, minutes)
          }
          className="w-16"
        />
      </div>
      <div className="grid gap-1">
        <Label htmlFor="minutes" className="text-xs">
          Minutes
        </Label>
        <Input
          id="minutes"
          type="number"
          min="0"
          max="59"
          value={minutes}
          onChange={(e) =>
            handleTimeChange(hours, parseInt(e.target.value) || 0)
          }
          className="w-16"
        />
      </div>
    </div>
  );
}